import { ORDER_STATUSES } from 'utils/order/constants';

export const ORDER_STATUSES_MAP = {
  [ORDER_STATUSES.PENDING_MODERATION]: {
    step: 1,
    label: 'OrderStop:label.global_state.created',
  },
  [ORDER_STATUSES.PENDING_ASSIGNMENT]: {
    step: 1,
    label: 'OrderStop:label.global_state.created',
  },
  [ORDER_STATUSES.ASSIGNED]: {
    step: 2,
    label: 'OrderStop:label.global_state.assigned',
  },
  [ORDER_STATUSES.IN_TRANSIT]: {
    step: 3,
    label: 'OrderStop:label.global_state.transit',
  },
  [ORDER_STATUSES.DONE]: {
    step: 4,
    label: 'OrderStop:label.global_state.finish',
  },
  [ORDER_STATUSES.DONE_WITHOUT_MANIFEST]: {
    step: 4,
    label: 'OrderStop:label.global_state.finish',
  },
  [ORDER_STATUSES.CANCELLED]: {
    step: 4,
    label: 'OrderStop:label.global_state.cancel',
  },
  [ORDER_STATUSES.NON_CORE_PENDING_CONFIRMATION]: {
    step: 1,
    label: 'OrderStop:label.non_core.agent_working',
  },
};
